import React from "react";

const Java_Scanner_delimiter = () => {
  return (
    <div>
      <h1>Java Scanner delimiter</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Scanner delimiter in Java.</p>
    </div>
  );
};

export default Java_Scanner_delimiter;
